import React, {useContext} from 'react';
import {Modal, Button, Typography, Card, Space} from 'antd';
import {CreditCard} from '@mui/icons-material';
import {hasProfessionalAccount} from '../../utils/variables/userVariables';
import {UserContext} from '../../utils/UserContext';
import {accountSubscriptionAdAtom} from '../../utils/atoms';
import {useAtom} from 'jotai';

const {Title, Text} = Typography;

const AccountSubscriptionAd: React.FC = () => {
	const [visible, setVisible] = useAtom(accountSubscriptionAdAtom);
	// @ts-ignore
	const [currentUser] = useContext(UserContext);

	const isProfessional = currentUser && hasProfessionalAccount(currentUser);

	return (
		<Modal
			open={visible}
			destroyOnClose={true}
			footer={null}
			width={600}
			closable={false}
			maskClosable={false}
			centered
			styles={{mask: {backdropFilter: 'blur(10px)'}}}
			title={
				<div className="flex items-center gap-2">
					<CreditCard className="text-antBlue" />
					<span>Professional Account Subscription</span>
				</div>
			}>
			<Space direction="vertical" size="large" style={{width: '100%'}}>
				<Card className="bg-backgroundGreyBlue">
					<Title level={4}>Upgrade to Professional</Title>
					<Text>Get access to premium features and enhance your experience with a Professional account subscription.</Text>

					<div className="mt-4">
						<ul className="list-disc pl-6">
							<li>Post unlimited job listings</li>
							<li>Advanced candidate filtering</li>
							<li>Priority customer support</li>
							<li>Enhanced analytics dashboard</li>
						</ul>
					</div>
				</Card>

				<div className="flex justify-end gap-3">
					<Button onClick={() => setVisible(false)}>Maybe Later</Button>
					<Button type="primary" disabled={isProfessional}>
						{isProfessional ? 'Already Subscribed' : 'Upgrade Now'}
					</Button>
				</div>
			</Space>
		</Modal>
	);
};

export default AccountSubscriptionAd;
